import React, { useContext } from 'react';
import ClubList from '../ClubList/ClubList';
import { clubsContext } from '../../context/clubsContext';
import { LocalizationContext } from '../../context/localizationContext';
import keys from '../../keys.json';
import Styles from './RegisteredClubs.module.scss';

const RegisteredClubs = () => {
  const clubContext = useContext(clubsContext);
  const { state, dispatch } = clubContext;
  const { userClubs } = state;
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { tileText, linkMenuItems } = localizationState.localization;
  const { linkKeys } = keys;

  const handleAddClubClick = () => {
    dispatch({ type: 'SET_LINK_KEY', key: linkKeys?.addClub });
  };

  return (
    <div>
      {userClubs?.length ? (
        <div className={Styles.registeredClubsContainer}>
          <ClubList registered={true} />
        </div>
      ) : (
        <div className={Styles.noClubsMessage}>
          {tileText?.noClubs}
          <button
            className={Styles.addClubBtn}
            type="button"
            onClick={() => handleAddClubClick()}
          >
            {linkMenuItems?.addClub}
          </button>
        </div>
      )}
    </div>
  );
};

export default RegisteredClubs;
